/**
 * Abre um fluxo de upsell somente quando a condição de elegibilidade é atendida.
 * Retorna true se o fluxo foi aberto.
 */
export function openUpsellFlow(flowRef, isEligible) {
  if (!isEligible) {
    return false
  }

  return flowRef.current?.open() ?? false
}
